/* Hortelã 2.0 · banners da página inicial (carrossel) */
(function () {
  if (!window.customElements || customElements.get('h2-banners')) return;

  class H2Banners extends HTMLElement {
    connectedCallback() {
      if (this._pronto) return;
      this._pronto = true;

      // Celular: o botão do WhatsApp só aparece quando o banner sai da tela, para não cobrir o botão do banner
      var raiz = document.documentElement;
      if ('IntersectionObserver' in window) {
        this._heroi = new IntersectionObserver(function (entradas) {
          var en = entradas[entradas.length - 1];
          raiz.classList.toggle('h2-heroi-fora', !(en.isIntersecting && en.intersectionRatio >= 0.75));
        }, { threshold: [0, 0.75] });
        this._heroi.observe(this);
      } else {
        raiz.classList.add('h2-heroi-fora');
      }

      this.trilho = this.querySelector('[data-trilho]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-slide]'));
      this.barras = Array.prototype.slice.call(this.querySelectorAll('[data-ir]'));
      this.botaoPausa = this.querySelector('[data-pausa]');
      this.motivos = new Set();
      this.atual = 0;
      this.alvo = null;
      if (!this.trilho || this.slides.length < 2) return;

      var reduzido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.suave = !reduzido;
      this.auto = this.getAttribute('data-autoplay') === 'true' && !reduzido;

      var el = this;
      this.barras.forEach(function (b, i) { b.addEventListener('click', function () { el.ir(i); }); });
      var ant = this.querySelector('[data-anterior]');
      var prox = this.querySelector('[data-proximo]');
      if (ant) ant.addEventListener('click', function () { el.ir(el.atual - 1); });
      if (prox) prox.addEventListener('click', function () { el.ir(el.atual + 1); });
      if (this.botaoPausa) this.botaoPausa.addEventListener('click', function () { if (el.auto) { el.parar(); } else { el.continuar(); } });

      this.addEventListener('animationend', function (e) {
        if (e.animationName === 'h2-banners-encher' && el.auto && !el.motivos.size) el.ir(el.atual + 1);
      });
      this.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') el.pausar('mouse'); });
      this.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') el.retomar('mouse'); });
      this.addEventListener('focusin', function (e) { if (e.target.matches && e.target.matches(':focus-visible')) el.pausar('foco'); });
      this.addEventListener('focusout', function (e) { if (!el.contains(e.relatedTarget)) el.retomar('foco'); });
      this.trilho.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') el.parar(); }, { passive: true });
      this.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { el.ir(el.atual + 1); }
        else if (e.key === 'ArrowLeft') { el.ir(el.atual - 1); }
      });

      this._aba = function () { if (document.hidden) { el.pausar('aba'); } else { el.retomar('aba'); } };
      document.addEventListener('visibilitychange', this._aba);
      this._seleciona = function (e) {
        var s = e.target && e.target.closest ? e.target.closest('[data-slide]') : null;
        if (!s || !el.contains(s)) return;
        el.pausar('editor');
        el.ir(el.slides.indexOf(s), false);
      };
      this._solta = function (e) { if (el.contains(e.target)) el.retomar('editor'); };
      document.addEventListener('shopify:block:select', this._seleciona);
      document.addEventListener('shopify:block:deselect', this._solta);

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (en) {
            if (!en.isIntersecting || en.intersectionRatio < 0.6) return;
            var k = el.slides.indexOf(en.target);
            if (el.alvo !== null && k !== el.alvo) return;
            if (k === el.alvo) el.alvo = null;
            if (k !== el.atual) el.marcar(k);
          });
        }, { root: this.trilho, threshold: [0.6] });
        this.slides.forEach(function (s) { el.io.observe(s); });
      }

      this.atualizarPausa();
      this.marcar(0);

      var carregar = function () {
        setTimeout(function () {
          el.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
        }, 1200);
      };
      if (document.readyState === 'complete') { carregar(); } else { window.addEventListener('load', carregar, { once: true }); }
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this._heroi) this._heroi.disconnect();
      document.documentElement.classList.remove('h2-heroi-fora');
      if (this._aba) document.removeEventListener('visibilitychange', this._aba);
      if (this._seleciona) document.removeEventListener('shopify:block:select', this._seleciona);
      if (this._solta) document.removeEventListener('shopify:block:deselect', this._solta);
      this._pronto = false;
    }

    ir(i, suave) {
      var n = this.slides.length;
      i = ((i % n) + n) % n;
      var el = this;
      this.alvo = i;
      clearTimeout(this._limpa);
      this._limpa = setTimeout(function () { el.alvo = null; }, 1000);
      this.trilho.scrollTo({ left: i * this.trilho.clientWidth, behavior: (suave === false || !this.suave) ? 'auto' : 'smooth' });
      this.marcar(i);
    }

    marcar(i) {
      this.atual = i;
      this.slides.forEach(function (s, k) {
        if (k === i) { s.removeAttribute('inert'); } else { s.setAttribute('inert', ''); }
      });
      this.setAttribute('data-tema', this.slides[i].getAttribute('data-tema') || 'claro');
      this.barras.forEach(function (b, k) {
        b.classList.remove('is-ativa');
        if (k === i) { b.setAttribute('aria-current', 'true'); } else { b.removeAttribute('aria-current'); }
      });
      var barra = this.barras[i];
      if (barra) { void barra.offsetWidth; barra.classList.add('is-ativa'); }
    }

    pausar(motivo) { this.motivos.add(motivo); this.atualizarPausa(); }
    retomar(motivo) { this.motivos.delete(motivo); this.atualizarPausa(); }
    parar() { this.auto = false; this.atualizarPausa(); }
    continuar() { this.auto = true; this.atualizarPausa(); this.marcar(this.atual); }

    atualizarPausa() {
      this.toggleAttribute('data-parado', !this.auto);
      this.toggleAttribute('data-pausado', !this.auto || this.motivos.size > 0);
      this.trilho.setAttribute('aria-live', this.auto ? 'off' : 'polite');
      if (this.botaoPausa) this.botaoPausa.setAttribute('aria-label', this.auto ? 'Pausar os banners' : 'Continuar passando os banners');
    }
  }

  customElements.define('h2-banners', H2Banners);
})();
